import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { GET_SIDEBAR_CONFIGURATION } from '../store/actions';
import { withDomainQueryParams } from '../Routes/domainConfig';

const NavdataV2 = () => {
  const dispatch = useDispatch();
  const [menuState, setMenuState] = useState({});
  const [currentState, setCurrentState] = useState('');

  const { getSidebarConfiguration } = useSelector(state => ({
    getSidebarConfiguration: state.GetSidebarConfiguration.data,
  }));

  useEffect(() => {
    dispatch({ type: GET_SIDEBAR_CONFIGURATION });
  }, []);

  const toggleMenu = (key, e) => {
    e?.preventDefault?.();
    updateIconSidebar(e);
    setMenuState(prev => ({ ...prev, [key]: !prev[key] }));
    setCurrentState(key);
  };

  const updateIconSidebar = e => {
    if (e?.target?.getAttribute('subitems')) {
      const ul = document.getElementById('two-column-menu');
      const iconItems = ul?.querySelectorAll('.nav-icon.active') || [];
      [...iconItems].forEach(item => {
        item.classList.remove('active');
        const id = item.getAttribute('subitems');
        if (document.getElementById(id)) {
          document.getElementById(id).classList.remove('show');
        }
      });
    }
  };

  const getTimelineQueryParams = label => {
    const currentDate = moment();
    let startDate = '';
    let endDate = '';

    switch (label) {
      case 'Upcoming Bookings':
        startDate = currentDate.clone().add(2, 'days').startOf('day').format('YYYY-MM-DD');

        endDate = currentDate.clone().add(30, 'days').endOf('day').format('YYYY-MM-DD');
        break;

      case 'Ongoing Bookings':
        startDate = currentDate.clone().subtract(2, 'days').startOf('day').format('YYYY-MM-DD');

        endDate = currentDate.clone().add(2, 'days').endOf('day').format('YYYY-MM-DD');
        break;

      case 'Past Bookings':
        startDate = currentDate.clone().subtract(3, 'months').subtract(2, 'days').startOf('day').format('YYYY-MM-DD');

        endDate = currentDate.clone().subtract(2, 'days').endOf('day').format('YYYY-MM-DD');
        break;

      default:
        return '';
    }

    return `&startDate=${startDate}&endDate=${endDate}`;
  };

  // Sub-menu icons: pick by label keyword first, otherwise cycle through the
  // pool so sibling items get distinct icons (the API sends no icon field).
  const SUBMENU_ICON_BY_KEYWORD = [
    [/dashboard/i, 'ri-dashboard-2-line'],
    [/booking/i, 'ri-calendar-check-line'],
    [/campaign/i, 'ri-flashlight-line'],
    [/vendor|supplier/i, 'ri-store-2-line'],
    [/user|customer|client|member/i, 'ri-user-3-line'],
    [/report|analytic|summary/i, 'ri-bar-chart-2-line'],
    [/setting|config/i, 'ri-settings-3-line'],
    [/payment|invoice|billing|price|pricing/i, 'ri-bank-card-line'],
    [/upload|import/i, 'ri-upload-2-line'],
    [/download|export/i, 'ri-download-2-line'],
    [/golf/i, 'ri-flag-line'],
    [/airport|meet|greet|pick|drop/i, 'ri-plane-line'],
    [/rule|workflow/i, 'ri-git-branch-line'],
    [/coupon|voucher|benefit|offer/i, 'ri-coupon-3-line'],
  ];

  const SUBMENU_ICON_POOL = [
    'ri-folder-2-line',
    'ri-file-list-3-line',
    'ri-price-tag-3-line',
    'ri-stack-line',
    'ri-pie-chart-2-line',
    'ri-links-line',
    'ri-shape-2-line',
    'ri-compass-3-line',
  ];

  const getSubmenuIcon = (label, index) => {
    const match = SUBMENU_ICON_BY_KEYWORD.find(([pattern]) => pattern.test(label || ''));
    return match ? match[1] : SUBMENU_ICON_POOL[index % SUBMENU_ICON_POOL.length];
  };

  const buildMenu = (items, parentKey, depth = 0) => {
    return items
      ?.sort((a, b) => a.priority - b.priority)
      .map((item, index) => {
        const key = item.key;
        const hasChildren = item.children?.length > 0;

        const baseLink =
          item.route && item.cardName && item.cardType
            ? `${item.route}?name=${item.cardName}&type=${item.cardType}&nextNavigation=${item.nextNavigation}`
            : item.route || '#';

        const timelineParams = getTimelineQueryParams(item.label);
        const finalLink = timelineParams ? `${baseLink}&${timelineParams}` : `${baseLink}`;

        return {
          id: key,
          label: item.label,
          icon: depth === 0 ? 'ri-dashboard-2-line' : getSubmenuIcon(item.label, index),
          // Routes come from the sidebar API, so they carry no domain params. On edge.thriwe.com the
          // link has to keep `userVersion=v2` or navigating away from the landing URL drops the
          // `User-Version` header off every API call the next page makes. No-op on other domains.
          link: item.route ? withDomainQueryParams(finalLink) : '#',
          stateVariables: !!menuState[key],
          click: e => toggleMenu(key, e),
          subItems: hasChildren ? buildMenu(item.children, key, depth + 1) : [],
        };
      });
  };

  const menuItems = buildMenu(getSidebarConfiguration?.configurations || []);

  return <>{menuItems}</>;
};

export default NavdataV2;
